import {
  e as e3
} from "./chunk.7ZTMBV6K.js";
import {
  icon_styles_default
} from "./chunk.Z4Y2Z74L.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  SlIcon,
  getIconLibrary,
  requestIcon
} from "./chunk.PZJQ42VP.js";
import {
  e as e2
} from "./chunk.2JQPDYNA.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// node_modules/lit-html/directives/unsafe-svg.js
var t = class extends e3 {
};
t.directiveName = "unsafeSVG", t.resultType = 2;
var o = e2(t);

// src/components/icon/icon.ts
var parser = new DOMParser();
var id = 0;
var FadvIcon = class extends SlIcon {
  constructor() {
    super(...arguments);
    this.componentId = `foreground-${++id}`;
  }
  async setIcon() {
    var _a;
    const library = getIconLibrary(this.library);
    const url = this["getUrl"]();
    if (url) {
      try {
        const file = await requestIcon(url);
        if (url !== this["getUrl"]()) {
          return;
        } else if (file.ok) {
          const doc = parser.parseFromString(file.svg, "text/html");
          const svgEl = doc.body.querySelector("svg");
          if (svgEl !== null) {
            (_a = library == null ? void 0 : library.mutator) == null ? void 0 : _a.call(library, svgEl);
            svgEl.setAttribute("part", "svg");
            svgEl.style.fill = `url(#${this.componentId})`;
            this.applyGradient(svgEl);
            this["svg"] = svgEl.outerHTML;
            emit(this, "sl-load");
          } else {
            this["svg"] = "";
            emit(this, "sl-error");
          }
        } else {
          this["svg"] = "";
          emit(this, "sl-error");
        }
      } catch (e4) {
        emit(this, "sl-error");
      }
    } else if (this["svg"].length > 0) {
      this["svg"] = "";
    }
  }
  applyGradient(svg) {
    if (svg.querySelector("#foreground"))
      return;
    const start = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    start.id = "foreground-start";
    start.setAttribute("part", "foreground-start");
    start.setAttribute("offset", "0%");
    start.setAttribute("stop-color", "currentColor");
    const end = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    end.id = "foreground-end";
    end.setAttribute("part", "foreground-end");
    end.setAttribute("offset", "100%");
    end.setAttribute("stop-color", "currentColor");
    const gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
    gradient.id = `${this.componentId}`;
    gradient.setAttribute("x1", "0%");
    gradient.setAttribute("y1", "0%");
    gradient.setAttribute("x2", "100%");
    gradient.setAttribute("y2", "100%");
    gradient.append(start, end);
    const existingDefs = svg.querySelector("defs");
    if (existingDefs) {
      existingDefs.append(gradient);
    } else {
      const defs = document.createElementNS('"http://www.w3.org/2000/svg"', "defs");
      defs.append(gradient);
      svg.append(defs);
    }
  }
  renderInterior() {
    const svg = $`${o(this["svg"])}`;
    return this.outline ? $`<div class="icon__outline-background">${svg}</div>` : svg;
  }
  render() {
    const hasLabel = typeof this.label === "string" && this.label.length > 0;
    return $`<div part="base" class="icon" role=${l(hasLabel ? "img" : void 0)} aria-label=${l(hasLabel ? this.label : void 0)} aria-hidden=${l(hasLabel ? void 0 : "true")} >${this.renderInterior()}</div>`;
  }
};
FadvIcon.styles = icon_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvIcon.prototype, "foreground", 2);
__decorateClass([
  e({ reflect: true })
], FadvIcon.prototype, "background", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvIcon.prototype, "outline", 2);
__decorateClass([
  e({ reflect: true })
], FadvIcon.prototype, "size", 2);
FadvIcon = __decorateClass([
  n("fadv-icon")
], FadvIcon);

export {
  FadvIcon
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
